import {
  NgxMatDatetimePickerModule,
  NGX_MAT_DATE_FORMATS,
} from '@angular-material-components/datetime-picker';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { LeafletMarkerClusterModule } from '@asymmetrik/ngx-leaflet-markercluster';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonLinkComponent } from './button-link/buttonlink.component';
import { ButtonComponent } from './button/button.component';
import { CardSelectComponent } from './card-select/card-select.component';
import { ChipsSelectComponent } from './chips-select/chips-select.component';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { LocationComponent } from './location/location.component';
import { NoticeComponent } from './notice/notice.component';
import { SmsVerificationComponent } from './sms-verification/sms-verification.component';
import { SourcesComponent } from './sources/sources.component';
import { UploaderComponent } from './uploader/uploader.component';

// Custom date format for datetime picker: MM/DD/YYYY, h:mm a
const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'MM/DD/YYYY, h:mm A',
  },
  display: {
    dateInput: 'MM/DD/YYYY, h:mm A',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

const components = [
  ButtonComponent,
  ButtonLinkComponent,
  LanguageSelectorComponent,
  ChipsSelectComponent,
  CardSelectComponent,
  NoticeComponent,
  SourcesComponent,
  UploaderComponent,
  SmsVerificationComponent,
  LocationComponent,
];

const modules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  TranslateModule,
  LeafletModule,
  LeafletMarkerClusterModule,
];

const material = [
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDividerModule,
  MatFormFieldModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatSelectModule,
  MatSidenavModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatToolbarModule,
  NgxMatDatetimePickerModule,
  NgxMatMomentModule,
];

@NgModule({
  declarations: [...components],
  imports: [...modules, ...material],
  exports: [...components, ...modules, ...material],
  providers: [{ provide: NGX_MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
